import { render } from "./UpWizardDrugs.vue?vue&type=template&id=770788d2&scoped=true"
import script from "./UpWizardDrugs.vue?vue&type=script&lang=js"
export * from "./UpWizardDrugs.vue?vue&type=script&lang=js"

import "./UpWizardDrugs.vue?vue&type=style&index=0&id=770788d2&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770788d2"]])

export default __exports__